import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Sparkles } from 'lucide-react';

export default function Hero() {
  const spotRef = useRef(null);

  // Subtle mouse-follow spotlight
  useEffect(() => {
    const el = spotRef.current;
    if (!el) return;
    const onMove = (e) => {
      const rect = el.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      el.style.setProperty('--mx', `${x}%`);
      el.style.setProperty('--my', `${y}%`);
    };
    window.addEventListener('mousemove', onMove);
    return () => window.removeEventListener('mousemove', onMove);
  }, []);

  return (
    <section ref={spotRef} className="relative overflow-hidden hero-spot">
      <div className="absolute inset-0 pointer-events-none noise-bg" />
      <div className="max-w-7xl mx-auto px-5 lg:px-8 pt-12 pb-20 lg:pt-28 lg:pb-32 grid lg:grid-cols-2 gap-10 items-center relative">
        <div className="fade-up">
          <span className="inline-flex items-center gap-2 text-xs font-semibold px-3 py-1.5 rounded-full" style={{ background: 'var(--pill-hover)', border: '1px solid var(--border)' }}>
            <Sparkles size={12} className="text-cyan-500" />
            Roblox Türkiye'nin Favorisi
          </span>
          <h1 className="mt-5 text-[42px] sm:text-5xl lg:text-[68px] leading-[1.05] font-semibold tracking-tight">
            <span className="grad-text">Sevdiğimiz oyunları</span>
            <br />
            <span>birlikte yapıyoruz.</span>
          </h1>
          <p className="mt-6 max-w-xl text-[16px] leading-relaxed" style={{ color: 'var(--text-muted)' }}>
            Hızlı tempolu nişancı oyunlarından rol yapma deneyimlerine kadar — TO Studios, oyuncu odaklı ve topluluk destekli projeler üretir.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <a href="#games" className="pill-btn !px-6 !py-3 font-semibold" style={{ background: 'var(--text)', color: 'var(--bg)', borderColor: 'transparent' }}>
              Oyunları Keşfet
              <ArrowRight size={16} />
            </a>
            <Link to="/wiki" className="pill-btn !px-6 !py-3 font-semibold">Wiki'yi Gezin</Link>
          </div>
          <div className="mt-10 flex items-center gap-6 text-sm" style={{ color: 'var(--text-muted)' }}>
            <div className="flex items-center gap-2"><span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse" /> Canlı topluluk</div>
            <div className="flex items-center gap-2">2022'den beri</div>
          </div>
        </div>

        <div className="relative h-[380px] lg:h-[560px]">
          <div className="absolute inset-0 hero-blob" />
          <div className="relative w-full h-full flex items-center justify-center">
            <div className="relative w-[340px] h-[340px] lg:w-[500px] lg:h-[500px] rounded-[42px] overflow-hidden tilt-card flex items-center justify-center">
              <img
                src="/images/img1.jpg"
                alt="TO Studios"
                className="w-full h-full object-cover"
              />
              <div className="absolute -top-6 -right-6 w-24 h-24 rounded-3xl rotate-12" style={{ background: 'linear-gradient(135deg, #4cc9f0, #7aa7ff)' }} />
              <div className="absolute -bottom-6 -left-6 w-20 h-20 rounded-2xl -rotate-12" style={{ background: 'linear-gradient(135deg, #ff6fa8, #ffc266)' }} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
